import onSelectionChange from '../events/onSelectionChange';
import toggleSelectAllRowsInternal from '../internal/toggleSelectAllRowsInternal';
import * as mailListSelectionActions from 'owa-mail-actions';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import { orchestrator } from 'satcheljs';
import setSelectionAnchorRowKey from '../internal/mutators/setSelectionAnchorRowKey';
import setMultiSelectionAnchorRowKey from '../internal/mutators/setMultiSelectionAnchorRowKey';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Toggle between select all and clear selection on the table
 * @param tableView where the operation is being performed
 */
export default orchestrator(mailListSelectionActions.toggleSelectAllRows, function (actionMessage) {
    var tableView = actionMessage.tableView;
    var mailListItemSelectionSource = MailListItemSelectionSource.ToggleCheckAll;
    toggleSelectAllRowsInternal(tableView);
    if (isMailFeatureEnabled('tri-selectionRefactor') && !tableView.isInVirtualSelectAllMode) {
        setSelectionAnchorRowKey(tableView, tableView.rowKeys[tableView.rowKeys.length - 1]);
        setMultiSelectionAnchorRowKey(tableView, tableView.rowKeys[0]);
    }
    // Propagate selection change event
    onSelectionChange(tableView, true /* isUserNavigation */, mailListItemSelectionSource);
});
//# sourceMappingURL=toggleSelectAllRowsOrchestrator.js.map